////////LIBRARY/////////
import { find, isEmpty, map } from 'lodash'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
///////COMPONENTS///////
import { shortcutPicsConfig } from '../../../constants/AssetsPicturesConfigList'
import { uriList } from '../../../routings/settings/RouteList'
import KioskPerimeter from '../../KioskPerimeter'
import Modals from '../../Modals'
import Notifications from '../../Notifications'
import Tooltip from '../../Tooltip/Tooltip'
import TooltipHelp from '../../TooltipHelp'
import HeaderCarousel from './HeaderCarousel'
/////////ASSETS/////////
import MachinePoolPicto from '../../../assets/icones/global/edit-white.svg'
import MachinePoolIcon from '../../../assets/icones/header/kiosk.svg'
import HeaderLogoImg from '../../../assets/images/logo-we-deal-white.svg'

/////////STYLED/////////
const HeaderWrapper = styled.div`
	position: relative;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	background-color: ${(props) => props.theme.colors.primary};
	height: 95px;
	width: 100%;
`
const HeaderLogo = styled.img`
	margin: 20px;
`
const SocieteLogoHandler = styled.div`
	width: 151px;
	height: 61px;
	background-color: #fff;
	border-radius: 3px;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`
const SocieteLogo = styled.img`
	max-height: 51px;
	max-width: 141px;
	visibility: ${(props) => (props.visibility ? 'initial' : 'hidden')};
`
const UserWrapper = styled.div`
	width: 300px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	box-sizing: border-box;
	margin-left: 10px;
`
const UserNameText = styled.p`
	font-size: ${(props) => props.theme.font.fxl};
	color: ${(props) => props.theme.colors.white};
	text-decoration: underline;
	font-weight: 900;
	padding: 0;
	margin: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 100%;
`
const UserRoleText = styled.p`
	font-size: ${(props) => props.theme.font.fs};
	color: ${(props) => props.theme.colors.white};
	padding: 0;
	margin: 0;
`
const HeaderMachinePoolHandler = styled.div`
	width: 210px;
	height: 75px;
	position: absolute;
	right: 122px;
	display: inline-flex;
	flex-direction: row;
`
const HeaderMachinePoolImage = styled.img`
	width: 40px;
	height: 74px;
`
const HeaderMachinePoolTitleHandler = styled.div`
	display: flex;
	flex-direction: space-around;
	flex-direction: column;
	justify-content: space-evenly;
	margin-left: 16px;
`
const HeaderMachinePoolTitle = styled.span`
	font-size: ${(props) => props.theme.font.fm};
	color: ${(props) => props.theme.colors.white};
	font-weight: bold;
`
const HeaderMachinePoolInputHandler = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
`
const HeaderMachinePoolInput = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 7px 8px;
	color: ${(props) => props.theme.text.colors.primary};
	font-size: ${(props) => props.theme.font.fl};
	background-color: #fff;
	border-radius: 4px 0px 0px 4px;
	border-width: 0px;
	width: 87px;
	font-weight: bold;
	text-align: center;
	font-family: 'Lato', sans-serif;
	cursor: initial;
`
const HeaderMachinePoolButton = styled.button`
	background-color: ${(props) => props.theme.colors.buttons.dark};
	width: 50px;
	height: 40px;
	border-radius: 0px 4px 4px 0px;
	border-width: 0px;
	background-image: url(${MachinePoolPicto});
	background-repeat: no-repeat;
	background-position: center;
	cursor: pointer;
	background-size: 24px;
`
/////////STYLED/////////

const NavHeader = () => {
	const [hasCompanyLogo, setHasCompanyLogo] = useState(false)

	const [carouselItemList, setCarouselItemList] = useState([])

	const { user, toastSuccess, translations, kioskPerimeter } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			kioskPerimeter: state.kioskPerimeter,
			account: state.myAccount.items,
			toastSuccess: state.toastSuccess,
			notification: state.notifications.items,
		}),
		shallowEqual
	)

	const [showPerimeter, setShowPerimeter] = useState(false)
	const [firstName, setFirstName] = useState(user.identity.firstName)
	const [lastName, setLastName] = useState(user.identity.lastName)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleOpenPerimeter = () => {
		setShowPerimeter(true)
	}
	const handleClosePerimeter = () => {
		setShowPerimeter(false)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		setFirstName(user.identity.firstName)
		setLastName(user.identity.lastName)
		setHasCompanyLogo(user.identity.company.logoFileName?.length > 0)
	}, [user])

	useEffect(() => {
		if (kioskPerimeter.update && toastSuccess.show) handleClosePerimeter()
	}, [kioskPerimeter.update, toastSuccess.show])

	useEffect(() => {
		if (!isEmpty(user.identity.shorcuts)) {
			let ar = []
			map(user.identity.shorcuts, (elem) => {
				const pic = find(shortcutPicsConfig, { id: elem.id })
				const item = {
					icon: pic.picture,
					link: `/${elem.url}`,
					translationKey: elem.translationKey,
				}
				ar.push(item)
			})
			setCarouselItemList(ar)
		}
	}, [user.identity.shorcuts])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<HeaderWrapper>
			{/*KIOSK PERMIMETER*/}
			<Modals showModal={showPerimeter} closeModalHandler={handleClosePerimeter} minWidth={1200}>
				<KioskPerimeter closeModal={handleClosePerimeter} />
			</Modals>
			<Link to={uriList.home}>
				<HeaderLogo src={HeaderLogoImg} />
			</Link>
			<SocieteLogoHandler>
				<SocieteLogo visibility={hasCompanyLogo} src={`/${user.identity.company.logoFileName}`} onError={() => setHasCompanyLogo(false)} />
			</SocieteLogoHandler>
			<UserWrapper>
				<UserNameText>
					{firstName} {lastName}
				</UserNameText>
				<UserRoleText>{user.identity.rolePrivileges.role.label}</UserRoleText>
			</UserWrapper>
			<HeaderCarousel items={carouselItemList} />
			<HeaderMachinePoolHandler>
				<HeaderMachinePoolImage src={MachinePoolIcon} />
				<HeaderMachinePoolTitleHandler>
					<TooltipHelp childrenPos={1} content={'tooltipHelp__admin__modal__body__kioskScope'} altImg>
						<HeaderMachinePoolTitle>{translations['common__text__header_kiosk']}</HeaderMachinePoolTitle>
					</TooltipHelp>
					<HeaderMachinePoolInputHandler>
						<HeaderMachinePoolInput>
							{`${user?.identity?.kioskSelected?.length} / ${user?.identity?.kiosksPool?.length}`}
						</HeaderMachinePoolInput>
						<Tooltip tooltipId={'kioskScope'} translationsKey={'tooltip__admin__header__kioskScope'}>
							<HeaderMachinePoolButton onClick={handleOpenPerimeter} />
						</Tooltip>
					</HeaderMachinePoolInputHandler>
				</HeaderMachinePoolTitleHandler>
			</HeaderMachinePoolHandler>
			{/* <Notifications /> */}
		</HeaderWrapper>
	)
}

NavHeader.propTypes = {}

export default NavHeader
